import React from "react";
import { Controller, useFormContext, FieldError } from "react-hook-form";

import { Select } from "ui/select";
import BorderStyle from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/components/border-style/border-style";

import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";
import { useButtonOptions } from "containers/admin/clients/client/theme-page/preview/hooks/use-button-option";
import { useButtonContent } from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/use-button-content";
import BorderRadiusCard from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/components/border-radius-card/border-radius-card";
import CustomButtonColor from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/components/custom-button-color/custom-button-color";
import ThemePadding from "containers/admin/clients/client/theme-page/preview/components/theme-padding/theme-padding";
import ButtonWidth from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/components/button-width/button-width";

import { ButtonTabInputType } from "containers/admin/clients/client/theme-page/preview/preview-sidebar/preview-sidebar.types";
import { CustomSelectOption } from "containers/admin/clients/client/theme-page/preview/preview.types";
import ButtonAlignment from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/components/button-alignment/button-alignment";

import {
  BORDER_RADIUS,
  BG_COLOR,
  BORDER_STYLE,
  CUSTOM_VALUE,
  NAME_VALUE,
  BUTTON_PADDING,
  BUTTON_ALIGNMENT,
} from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/button.constants";

const ButtonSectionContent = ({ content }: { content: ButtonTabInputType[] }) => {
  // context
  const { isEditMode, colors, typography, button } = useThemePreviewContext();

  //form
  const { control, watch } = useFormContext();

  // get button input options
  const BUTTON_OPTIONS = useButtonOptions();

  // button helper functions
  const {
    getSelectValue,
    isBorderRadiusCardOpen,
    // handleRadiusBtnClick,
    setIsBorderRadiusCardOpen,
    getSectionErrors,
    handleCustomChange,
    handleChange,
  } = useButtonContent();

  const isThemeSet = typography && colors && button;

  return (
    isThemeSet && (
      <div className="flex flex-col gap-5">
        {/* Button Padding inputs */}
        <ThemePadding formFieldPrefix={BUTTON_PADDING} label="Padding (px)" />
        <ButtonWidth />
        <ButtonAlignment name={BUTTON_ALIGNMENT} label="Alignment" />
        {content.map(({ name, label, isRequired }: ButtonTabInputType, ind: number) => (
          <React.Fragment key={name + ind}>
            {/* Basic level button inputs */}
            <Controller
              name={`button.${name}.name`}
              control={control}
              render={({ field }) => (
                <div>
                  <div className="flex gap-2 items-end">
                    <Select
                      ariaLabel={label}
                      label={label}
                      selectName={`button-select-${name}`}
                      disableClearable
                      options={BUTTON_OPTIONS[name]}
                      required={isRequired}
                      disabled={!isEditMode}
                      {...field}
                      value={getSelectValue(name, field.value, false)}
                      onChange={(el) => {
                        // const isModalOpen = name === BORDER_RADIUS && el?.value === CUSTOM_VALUE;
                        // setIsBorderRadiusCardOpen(isModalOpen);
                        if (el) {
                          handleChange(name, el, NAME_VALUE, field.onChange);
                        }
                      }}
                    />
                    {/* Button next to border radius - HIDDEN till v2*/}
                    {/* {name === BORDER_RADIUS && (
                      <CustomButton
                        layout="icon"
                        theme="invert"
                        isDisabled={!isEditMode}
                        onClick={() => {
                          handleRadiusBtnClick(name, field);
                        }}>
                        <Icons.BorderRadius />
                      </CustomButton>
                    )} */}
                  </div>
                  {/* Modal for custom border radius */}
                  {name === BORDER_RADIUS && (
                    <Controller
                      name={`button.${BORDER_RADIUS}.custom`}
                      control={control}
                      render={({ field }) => (
                        <BorderRadiusCard
                          isOpen={isBorderRadiusCardOpen}
                          onClose={() => setIsBorderRadiusCardOpen(false)}
                          error={(getSectionErrors(BORDER_RADIUS)?.custom as FieldError)?.message}
                          onConfirm={(value) => {
                            handleCustomChange(value, BORDER_RADIUS, CUSTOM_VALUE, field.onChange);
                          }}
                        />
                      )}
                    />
                  )}
                </div>
              )}
            />
            {/* custom background color input */}
            {name === BG_COLOR && watch(`button.${BG_COLOR}`)?.name?.value === CUSTOM_VALUE && (
              <CustomButtonColor section={BG_COLOR} label="Button background custom color" />
            )}
            {/* border style section */}
            {name === BORDER_STYLE && <BorderStyle />}
          </React.Fragment>
        ))}
      </div>
    )
  );
};

export default ButtonSectionContent;
